import React from 'react';
import AIMessage from '../messages/AIMessage';
import UserMessage from '../messages/UserMessage';
import TypingIndicator from '../messages/TypingIndicator';
import styles from '../../styles/chatV2.module.css';

/**
 * MessageList Component
 * Renders the scrollable list of chat messages
 */
const MessageList = ({
  messages = [],
  isStreaming = false,
  onRegenerate,
  onFeedback,
  onCopy,
  onShare,
  user,
}) => {
  return (
    <div className={styles.messageList}>
      {messages.map((message, index) => {
        const key = message.id || `message-${index}`;

        if (message.role === 'user') {
          return <UserMessage key={key} message={message} user={user} />;
        }

        if (message.role === 'assistant') {
          return (
            <AIMessage
              key={key}
              message={message}
              isStreaming={message.isStreaming || false}
              onRegenerate={() => onRegenerate(message)}
              onFeedback={(type) => onFeedback(message, type)}
              onCopy={() => onCopy(message)}
              onShare={() => onShare(message)}
            />
          );
        }

        return null;
      })}

      {/* Show typing indicator when waiting for first chunk */}
      {isStreaming && !messages.some((m) => m.isStreaming) && <TypingIndicator />}
    </div>
  );
};

export default MessageList;
